import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { css } from '@patternfly/react-styles';
import { ToolbarContext, ToolbarContentContext } from './ToolbarUtils';
import { Button } from '../Button';
import globalBreakpointLg from '@patternfly/react-tokens/dist/js/global_breakpoint_lg';
import { formatBreakpointMods, toCamel, capitalize } from '../../helpers/util';
export var ToolbarToggleGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarToggleGroup, _React$Component);

  function ToolbarToggleGroup() {
    var _this;

    _classCallCheck(this, ToolbarToggleGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarToggleGroup).apply(this, arguments));

    _this.isContentPopup = function () {
      var viewportSize = window.innerWidth;
      var lgBreakpointValue = parseInt(globalBreakpointLg.value);
      return viewportSize < lgBreakpointValue;
    };

    return _this;
  }

  _createClass(ToolbarToggleGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          toggleIcon = _a.toggleIcon,
          variant = _a.variant,
          visiblity = _a.visiblity,
          breakpoint = _a.breakpoint,
          alignment = _a.alignment,
          spacer = _a.spacer,
          spaceItems = _a.spaceItems,
          className = _a.className,
          children = _a.children,
          props = __rest(_a, ["toggleIcon", "variant", "visiblity", "breakpoint", "alignment", "spacer", "spaceItems", "className", "children"]);

      if (!breakpoint && !toggleIcon) {
        // eslint-disable-next-line no-console
        console.error('ToolbarToggleGroup will not be visible without a breakpoint or toggleIcon.');
      }

      return React.createElement(ToolbarContext.Consumer, null, function (_ref) {
        var isExpanded = _ref.isExpanded,
            toggleIsExpanded = _ref.toggleIsExpanded;
        return React.createElement(ToolbarContentContext.Consumer, null, function (_ref2) {
          var expandableContentRef = _ref2.expandableContentRef,
              expandableContentId = _ref2.expandableContentId;

          if (expandableContentRef.current && expandableContentRef.current.classList) {
            if (isExpanded) {
              expandableContentRef.current.classList.add(styles.modifiers.expanded);
            } else {
              expandableContentRef.current.classList.remove(styles.modifiers.expanded);
            }
          }

          return React.createElement("div", Object.assign({
            className: css(styles.toolbarGroup, styles.modifiers.toggleGroup, variant && styles.modifiers[toCamel(variant)], breakpoint && styles.modifiers["showOn".concat(capitalize(breakpoint.replace('2xl', '_2xl')))], formatBreakpointMods(visiblity, styles), formatBreakpointMods(alignment, styles), formatBreakpointMods(spacer, styles), formatBreakpointMods(spaceItems, styles), className)
          }, props), React.createElement("div", {
            className: css(styles.toolbarToggle)
          }, React.createElement(Button, Object.assign({
            variant: "plain",
            onClick: toggleIsExpanded,
            "aria-label": "Show Filters"
          }, isExpanded && {
            'aria-expanded': true
          }, {
            "aria-haspopup": isExpanded && _this2.isContentPopup(),
            "aria-controls": expandableContentId
          }), toggleIcon)), isExpanded ? ReactDOM.createPortal(children, expandableContentRef.current.firstElementChild) : children);
        });
      });
    }
  }]);

  return ToolbarToggleGroup;
}(React.Component);